<div [ngClass]="{ 'has-edit-button': isEditMode }">
  <!-- edit button -->
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
  <ng-container *ngIf="isHandheld$ | async">
    <eds-floating-action-button
      [quicklinksLabel]="'common.fba-quicklinks' | translate"
      [showButtons]="true"
      [moreContentText]="'common.fba-more-content' | translate"
    >
      <div quicklinks class="floating-action-button__quicklinks">
        <div *ngFor="let link of links; let i = index">
          <a
            edsPadding
            edsPaddingAll="md"
            [href]="link.href"
            [ngClass]="link?.externalLink"
            [target]="link?.isNewWindow ? '_blank' : '_self'"
            class="sidebar__list-item sidebar__list-item--black"
            edsFlexbox
            alignItems="center"
            justifyContent="space-between"
          >
            <div edsPadding edsPaddingRight="xs">{{ link.text }}</div>
            <eds-icon
              class="sidebar__icon--primary"
              type="carrot-right"
              size="small"
            ></eds-icon>
          </a>
          <eds-divider *ngIf="i < links.length - 1"></eds-divider>
        </div>
      </div>
    </eds-floating-action-button>
  </ng-container>
</div>

<!-- No Document -->
<div *ngIf="!document && isEditMode" class="no-document" edsPadding>
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>{{ componentLabel }}</strong>
    </div>
  </div>
</div>
